import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { bootstrapTheme } from './lib/theme';
import { initSentry } from './lib/sentry';
import { captureImpersonationToken } from './lib/impersonation';
import './i18n'; // i18next init (TR varsayılan + fallback, EN ikincil) — React mount'tan önce.
import './styles/globals.css';

// Sprint 34 — `?imp=<token>` parametresini React mount'tan ÖNCE yakala:
// token'ı sessionStorage'a al + adres çubuğundan temizle (api client bearer ile gönderir).
captureImpersonationToken();
// Tema flicker'ı önlemek için React mount'tan ÖNCE uygula.
bootstrapTheme();
// Sentry — paket yüklü değilse no-op.
void initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          {/* BRANDBOOK §6.10 — toast pozisyon bottom-right (custom ToastProvider ile uyumlu) */}
          <Toaster richColors position="bottom-right" />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
